import { render, staticRenderFns } from "./UpdateDeliveryTypeDialog.vue?vue&type=template&id=02182c98&scoped=true&lang=pug&"
import script from "./UpdateDeliveryTypeDialog.vue?vue&type=script&lang=ts&"
export * from "./UpdateDeliveryTypeDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02182c98",
  null
  
)

export default component.exports